import React, { useMemo, useState } from 'react'

import { Carousel, Gallery } from '@guiker/picture-gallery-components'
import { NEWProperty } from '@guiker/real-estate-shared'

type PropertyPicturesProps = {
  property: NEWProperty
  showGallery?: boolean
}

export const PropertyPictures: React.FC<PropertyPicturesProps> = ({ property, showGallery = true }) => {
  const [isCarouselOpen, setIsCarouselOpen] = useState(false)
  const openCarousel = () => setIsCarouselOpen(true)
  const closeCarousel = () => setIsCarouselOpen(false)

  const pictures = useMemo(() => {
    if (!property) return []

    return property.pictures.map((p) => ({ url: p.url }))
  }, [property?.pictures])

  return (
    <div>
      <Gallery pictures={showGallery ? pictures : [pictures[0]]} onClick={showGallery && openCarousel} />
      {showGallery && <Carousel pictures={pictures} open={isCarouselOpen} closeModal={closeCarousel} />}
    </div>
  )
}
